module.exports = __webpack_public_path__ + "static/media/inspire.f3d2ed08.png";